import SectionOneAbout from './sectionOne';

export default function AboutSection() {
  return (
    <div>
      <SectionOneAbout />
    </div>
  );
}
